module.exports = __webpack_public_path__ + "img/Walone.ac8a5389.svg";